export default __webpack_public_path__ + "static/media/booking-button.f563418d.png";